<template>
	<o-select
		v-if="setup.companies.length > 0"
		v-model="setup.vModel"
		:options="setup.companies"
		track-key="id"
		display-key="name"
		value-key="id"
		v-bind="{
			label: setup.label,
			clearable,
			searchable: setup.searchable,
		}"
		@select="emits('select', $event)">
		<template #option="{ item }">
			<div>
				<div>
					{{ `${item.name} (${item.contactDetailCity})` }}
				</div>
				<o-label
					v-if="item.agencyCompanyName && !hideAgencyName"
					outline
					style="margin-top: 0.25rem;">
					{{ item.agencyCompanyName }}
				</o-label>
				<o-label
					v-if="checkOrderPlugin && !item.canCreateOrder"
					style="margin-top: 0.25rem;"
					color="warning"
					outline>
					{{ $t('common.shared.components.selectCompany.contactAgencyForOrder') }}
				</o-label>
			</div>
		</template>
	</o-select>
	<slot
		v-else
		name="empty"/>
</template>

<script setup lang="ts">
// #region Setup
import type { SharedSelectCompanyEmits, SharedSelectCompanyProps } from './SharedSelectCompanySetup';
import SharedSelectCompanySetup from './SharedSelectCompanySetup';
const emits = defineEmits<SharedSelectCompanyEmits>() as SharedSelectCompanyEmits;
const props = withDefaults(defineProps<SharedSelectCompanyProps>(), SharedSelectCompanySetup.defaultProps);
const setup = new SharedSelectCompanySetup(props, emits);
defineExpose(setup.publicInstance);
// #endregion
</script>
